module.exports = __webpack_public_path__ + "img/maya.a6b27154.svg";